<template>
    <div>
        <div
            class="row text-center foreignCountry-select foreignCountry-select-desktop"
            v-show="!isMobile"
        >
            <div class="foreignCountry-select_wrapper">
                <input
                    type="checkbox"
                    v-model="allowForeignPoints"
                    id="cbxAllowForeignPoints"
                    class="cbx"
                />
                <label for="cbxAllowForeignPoints" class="cbx_label">
                    {{ $t('origenODestinoFueraDe') }}
                    {{ config ? config.country_name : '' }}
                </label>
                <span
                    class="tooltip-bottom"
                    :data-tooltip="$t('marcandoEstaOpcionPodrasSeleccionar')"
                ></span>
                <i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
        </div>
        <div class="row search-section">
            <div class="col-xs-12 col-md-3">
                <button
                    class="btn btn-option btn-conductor"
                    :class="{ active: !isPassenger }"
                    @click="isPassenger = false"
                >
                    <span v-html="$t('buscoConductor')"></span>
                </button>
            </div>
            <div class="col-xs-12 col-md-3">
                <button
                    class="btn btn-option btn-passager"
                    :class="{ active: isPassenger }"
                    @click="isPassenger = true"
                >
                    <span>{{ $t('buscoPasajero') }}</span>
                </button>
            </div>
            <div
                class="row text-center foreignCountry-select foreignCountry-select-mobile"
                v-show="isMobile"
            >
                <div class="foreignCountry-select_wrapper">
                    <input
                        type="checkbox"
                        v-model="allowForeignPoints"
                        id="cbxAllowForeignPoints"
                        class="cbx"
                    />
                <label for="cbxAllowForeignPoints" class="cbx_label">
                    {{ $t('origenODestinoFueraDe') }}
                    {{ config ? config.country_name : '' }}
                </label>
                <span
                    class="tooltip-bottom"
                    :data-tooltip="$t('marcandoEstaOpcionPodrasSeleccionar')"
                ></span>
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="col-xs-24 col-md-5 gmap-autocomplete origin">
                <autocomplete
                    :placeholder="$t('origen')"
                    name="from_town"
                    ref="from_town"
                    :value="from_town.name"
                    v-on:place_changed="(data) => getPlace(0, data)"
                    :classes="'form-control form-control-with-icon form-control-map-autocomplete'"
                    :country="allowForeignPoints ? null : (config && config.osm_country)"
                ></autocomplete>
                <!-- <GmapAutocomplete name="from_town" ref="from_town" :selectFirstOnEnter="true" :types="['(cities)']"  :componentRestrictions="allowForeignPoints ? null : {country: 'AR'}"  placeholder="Origen"  :value="from_town.name" v-on:place_changed="(data) => getPlace(0, data)" class="form-control form-control-with-icon form-control-map-autocomplete"> </GmapAutocomplete>-->
                <div class="date-picker--cross">
                    <i
                        v-on:click="resetInput('from_town')"
                        class="fa fa-times"
                        aria-hidden="true"
                    ></i>
                </div>
                <div class="optional-warning text-center">({{ $t('opcional') }})</div>
                <div class="swap btn">
                    <img
                        alt="swap"
                        class="swap-horizontal"
                        :src="swap_horizontal"
                        @click="swapCities"
                    />
                    <img
                        alt="swap"
                        class="swap-vertical"
                        :src="swap_vertical"
                        @click="swapCities"
                    />
                </div>
            </div>
            <div class="col-xs-24 col-md-5 gmap-autocomplete destiny">
                <autocomplete
                    :placeholder="$t('destino')"
                    name="to_town"
                    ref="to_town"
                    :value="to_town.name"
                    v-on:place_changed="(data) => getPlace(1, data)"
                    :classes="'form-control form-control-with-icon form-control-map-autocomplete'"
                    :country="allowForeignPoints ? null : (config && config.osm_country)"
                ></autocomplete>
                <!-- <GmapAutocomplete name="to_town" ref="to_town" :selectFirstOnEnter="true" :types="['(cities)']"  :componentRestrictions="allowForeignPoints ? null : {country: 'AR'}"  placeholder="Destino"  :value="to_town.name" v-on:place_changed="(data) => getPlace(1, data)" class="form-control form-control-with-icon form-control-map-autocomplete"> </GmapAutocomplete> -->
                <div class="date-picker--cross">
                    <i
                        v-on:click="resetInput('to_town')"
                        class="fa fa-times"
                        aria-hidden="true"
                    ></i>
                </div>
                <div class="optional-warning text-center">({{ $t('opcional') }})</div>
            </div>
            <div class="col-xs-24 col-md-4 no-padding">
                <DatePicker
                    ref="datepicker"
                    :value="date"
                    :minDate="minDate"
                    :class="{ 'has-error': dateError.state }"
                ></DatePicker>
                <div class="optional-warning text-center">({{ $t('opcional') }})</div>
            </div>
            <div v-if="!autoSearch" class="col-xs-24 col-md-3 col-lg-4">
                <button class="btn btn-primary btn-search" @click="emit">
                    {{ $t('buscar') }} 
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DatePicker from '../DatePicker';
import autocomplete from '../Autocomplete.vue';
import bus from '../../services/bus-event.js';
import dayjs from '../../dayjs';
import dialogs from '../../services/dialogs.js';

export default {
    name: 'search-trip',
    data() {
        return {
            minDate: dayjs().toDate(),
            isPassenger: false,
            from_town: {
                name: '',
                location: null,
                radio: 0,
                country: ''
            },
            to_town: {
                name: '',
                location: null,
                radio: 0,
                country: ''
            },
            date: '',
            dateAnswer: '',
            dateError: {
                message: '',
                state: ''
            },
            chofer_logo_blanco:
                process.env.ROUTE_BASE +
                'static/img/icono-conductor-blanco.png',
            pasajero_logo_blanco:
                process.env.ROUTE_BASE + 'static/img/icono-pasajero-blanco.png',
            chofer_logo_gris:
                process.env.ROUTE_BASE + 'static/img/icono-conductor-gris.png',
            pasajero_logo_gris:
                process.env.ROUTE_BASE + 'static/img/icono-pasajero-gris.png',
            swap_horizontal:
                process.env.ROUTE_BASE + 'static/img/flechas_horizontales.png',
            swap_vertical:
                process.env.ROUTE_BASE + 'static/img/flechas_verticales.png',
            allowForeignPoints: false,
            options: []
        };
    },
    computed: {
        ...mapGetters({
            isMobile: 'device/isMobile',
            config: 'auth/appConfig'
        }),
        autoSearch() {
            return this.config.trips_auto_search && !this.isMobile;
        }
    },
    watch: {
        'from_town.id'(newVal) {
            if (this.autoSearch) {
                this.emit();
            }
        },
        'to_town.id'(newVal) {
            if (this.autoSearch) {
                this.emit();
            }
        },
        dateAnswer(newVal) {
            if (this.autoSearch) {
                this.emit();
            }
        },
        isPassenger() {
            if (this.autoSearch) {
                this.emit();
            }
        }
    },
    mounted() {
        bus.on('date-change', this.dateChange);
        this.loadParams(this.params);
        this.from_town.country = this.config.country_name;
        this.to_town.country = this.config.country_name;
        this.$refs['from_town'].$el.addEventListener('input', this.checkInput);
        this.$refs['to_town'].$el.addEventListener('input', this.checkInput);
    },
    updated() {},
    beforeDestroy() {
        this.$refs['from_town'].$el.removeEventListener(
            'input',
            this.checkInput
        );
        this.$refs['to_town'].$el.removeEventListener('input', this.checkInput);
        bus.off('date-change', this.dateChange);
    },
    methods: {
        dateChange(value) {
            this.dateAnswer = value;
        },
        checkInput(event) {
            let value = event.target.value;
            let name = event.target.name;
            if (value === '') {
                this[name] = '';
            }
        },
        // Fonction pour normaliser et comparer les pays
        isCountryMatch(country1, country2) {
            if (!country1 || !country2) return false;
            
            const c1 = country1.toLowerCase().trim();
            const c2 = country2.toLowerCase().trim();
            
            // Comparaison directe
            if (c1 === c2) return true;
            
            // Mapping des codes pays vers noms et vice-versa
            const countryMapping = {
                'fr': 'france',
                'france': 'fr',
                'french republic': 'france',
                'république française': 'france'
            };
            
            // Vérifier si c1 correspond à c2 via le mapping
            if (countryMapping[c1] === c2 || countryMapping[c2] === c1) {
                return true;
            }
            
            // Vérifier les premières lettres (FR vs FRance)
            if (c1.startsWith(c2) || c2.startsWith(c1)) {
                if (c1.length <= 3 || c2.length <= 3) {
                    return true;
                }
            }
            
            return false;
        },
        getPlace(i, data) {
            console.log('🔍 getPlace() appelé avec:', {
                index: i,
                data: data,
                country_from_api: data && data.country,
                config_country_name: this.config && this.config.country_name
            });
            let obj = {};
            // FIXME falta bounding box
            if (data) {
                obj = {
                    name: data.name,
                    location: {
                        lat: parseFloat(data.lat),
                        lng: parseFloat(data.lng)
                    },
                    country: data.country,
                    id: data.id
                };
            }
            if (i === 0) {
                this.from_town = obj;
                console.log('✅ FROM_TOWN mis à jour:', this.from_town);
                if (this.config.trips_focus_next) {
                    this.$refs.to_town.focus();
                }
            } else {
                this.to_town = obj;
                console.log('✅ TO_TOWN mis à jour:', this.to_town);
                if (this.config.trips_focus_next) {
                    this.$refs.datepicker.setFocus();
                }
            }
        },
        emit() {
            let params = {};
            let foreignCountry = 0;
            if (this.from_town.location) {
                console.log('from_town', this.from_town);
                params.origin_lat = this.from_town.location.lat;
                params.origin_lng = this.from_town.location.lng;
                params.origin_radio = this.from_town.radio;
                params.origin_name = this.from_town.name;
                params.origin_id = this.from_town.id;
            } else {
                params.origin_name = this.$refs['from_town'].input;
            }
            if (
                this.from_town &&
                this.from_town.country &&
                !this.isCountryMatch(this.from_town.country, this.config.country_name)
            ) {
                console.log('⚠️ FROM_TOWN détecté comme étranger:', {
                    from_country: this.from_town.country,
                    config_country: this.config.country_name
                });
                foreignCountry++;
            }
            if (this.to_town.location) {
                params.destination_lat = this.to_town.location.lat;
                params.destination_lng = this.to_town.location.lng;
                params.destination_radio = this.to_town.radio;
                params.destination_name = this.to_town.name;
                params.destination_id = this.to_town.id;
            } else {
                params.destination_name = this.$refs['to_town'].input;
            }
            if (
                this.to_town &&
                this.to_town.country &&
                !this.isCountryMatch(this.to_town.country, this.config.country_name)
            ) {
                console.log('⚠️ TO_TOWN détecté comme étranger:', {
                    to_country: this.to_town.country,
                    config_country: this.config.country_name
                });
                foreignCountry++;
            }
            if (this.dateAnswer) {
                params.date = this.dateAnswer;
            }
            params.is_passenger = this.isPassenger;
            if (foreignCountry < 2) {
                // console.log('trip-search', params);
                this.$emit('trip-search', params);
            } else {
                dialogs.message(
                    this.$t('origenYDestinoNoPuedenSerAmbosDelExterior'),
                    {
                        duration: 10,
                        estado: 'error'
                    }
                );
            }
        },
        resetInput(input) {
            if (this.$refs[input]) {
                this.$refs[input].input = '';
                this.$refs[input].focus();
            }
            this[input] = {
                name: '',
                location: null,
                radio: 0,
                country: this.config.osm_country
            };
        },
        swapCities() {
            let temp;
            temp = this['to_town'];
            this['to_town'] = Object.assign({}, this['from_town']);
            this['from_town'] = Object.assign({}, temp);
            
            // Search will only auto-trigger on desktop
            if (!this.isMobile && this.autoSearch) {
                this.emit();
            }
        },
        clear() {
            this.resetInput('from_town');
            this.$refs['from_town'].input = '';
            this.resetInput('to_town');
            this.$refs['to_town'].input = '';
            this.$refs.datepicker.clear();
        },
        loadParams(parameters) {
            if (parameters) {
                if (parameters.origin_name) {
                    this.from_town.name = parameters.origin_name;
                    this.from_town.location = {
                        lat: parameters.origin_lat,
                        lng: parameters.origin_lng
                    };
                    this.from_town.radio = parameters.origin_radio;
                    this.from_town.id = parameters.origin_id;
                } else {
                    this.resetInput('from_town');
                }

                if (parameters.destination_name) {
                    this.to_town.name = parameters.destination_name;
                    this.to_town.location = {
                        lat: parameters.destination_lat,
                        lng: parameters.destination_lng
                    };
                    this.to_town.radio = parameters.destination_radio;
                    this.to_town.id = parameters.destination_id;
                } else {
                    this.resetInput('to_town');
                }
                if (parameters.is_passenger) {
                    this.isPassenger = parameters.is_passenger;
                } else {
                    this.isPassenger = false;
                }
                if (parameters.date) {
                    this.date = parameters.date;
                } else {
                    this.date = '';
                }
            }
        },
        onSearch(search, loading) {
            loading(true);
            this.search(loading, search, this);
        }
    },
    props: ['params'],
    components: {
        DatePicker,
        autocomplete
    }
};
</script>

<style scoped>
.search-section {
    padding-left: 0;
    padding-right: 0;
}

.search-section .btn-option {
    width: 100%;
    margin-bottom: 1em;
}

/* Boutons Conducteur et Passager - style form-control standard */
.btn.btn-option.btn-conductor,
.btn.btn-option.btn-passager {
    height: auto !important;
    border-radius: 0;
    font-family: inherit;
    font-size: 13px !important;
    font-weight: normal;
    padding: .8em;
    border: 1px solid #BBBBBB;
    background: white;
    color: #666;
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.2;
    min-height: 30px;
}

.btn.btn-option.btn-conductor:hover,
.btn.btn-option.btn-passager:hover {
    border-color: #999;
    background: #f9f9f9;
}

.btn.btn-option.btn-conductor.active,
.btn.btn-option.btn-passager.active {
    background: #337ab7 !important;
    color: white !important;
    border-color: #2e6da4;
}

.btn.btn-option.btn-conductor span,
.btn.btn-option.btn-passager span,
.btn.btn-option.btn-conductor span strong,
.btn.btn-option.btn-passager span strong {
    font-size: 13px !important;
    font-weight: inherit;
    line-height: inherit;
}

/* Ancien styles pour compatibilité */
.btn-option {
    height: auto;
}

.btn-option .fa,
.btn-option img {
    display: none;
}
.swap {
    display: none;
}
.swap-horizontal {
    display: none;
}
.foreignCountry-select {
    margin-bottom: 1em;
}
.foreignCountry-select-mobile {
    width: 100%;
}
.foreignCountry-select-desktop .foreignCountry-select_wrapper {
    margin-left: -10%;
}
.cbx,
.cbx_label {
    vertical-align: middle;
    margin: 0;
}
.cbx_label {
    margin-left: 0.5em;
}
.optional-warning {
    font-size: 0.8em;
    color: #999;
    position: relative;
    top: -0.8em;
    clear: both;
}
@media only screen and (min-width: 300px) {
    .swap {
        bottom: -6px;
        left: -30px;
        border-radius: 0;
        position: absolute;
        z-index: 1;
        text-align: center;
        cursor: pointer;
        background-color: #eee;
        box-sizing: border-box;
        padding: 2px 6px 3px;
        border: 1px solid #aaa;
        display: inline-block;
        margin: 0em;
    }
    .search-section {
        margin-left: 30px;
        padding-right: 15px;
    }
}
@media only screen and (min-width: 429px) {
    .btn.btn-option.btn-conductor,
    .btn.btn-option.btn-passager {
        height: auto !important;
        min-height: 38px;
    }
}
@media only screen and (min-width: 768px) {
    .search-section {
        padding-left: 0;
        padding-right: 0;
        width: calc(100% - 30px);
    }
}
@media only screen and (min-width: 856px) {
    .search-section {
        width: 100%;
        margin-left: 0;
        padding-left: 0;
    }
}
@media only screen and (min-width: 992px) {
    .swap {
        bottom: unset;
        top: 20px;
        right: -17px;
        left: unset;
    }
    
    .btn.btn-option.btn-conductor,
    .btn.btn-option.btn-passager {
        height: auto !important;
        padding: .8em;
        font-size: 13px !important;
        line-height: 1.2;
        min-height: 30px;
    }
}
@media only screen and (min-width: 992px) {
    .swap-horizontal {
        display: block;
    }
    .swap-vertical {
        display: none;
    }
}
.search-section {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
}
</style>
